import { Box, Tab, Tabs } from '@mui/material'
import { useState } from 'react'
import { WrapperTable } from '../components'
import TabPermisoPorGrupo from './TabPermisoPorGrupo'
import TabPermisoPorEtapa from './TabPermisoPorEtapa'
import RUTAS from 'src/pages/admin/router/routes'

function ConfigEtapaGrupoPermiso() {
    const [tab, setTab] = useState(0)

    return (
        <WrapperTable goBackTo={`/${RUTAS.ADMIN_MASTER}`}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
                <Tabs value={tab} onChange={(_, v) => setTab(v)}>
                    <Tab label='Conf. por Grupo' />
                    <Tab label='Conf. por Etapa' />
                </Tabs>
            </Box>
            {tab === 0 && <TabPermisoPorGrupo />}
            {tab === 1 && <TabPermisoPorEtapa />}
        </WrapperTable>
    )
}

export default ConfigEtapaGrupoPermiso
